import "@turf/turf";
import "./index.es175.js";
import { calcFontSize as p } from "./index.es176.js";
import { fabric as m } from "fabric";
import { getMaxBoxHeight as S } from "./index.es456.js";
const a = {
  metricsContainer: {
    fillColor: "#f9f8f7"
  },
  metricsTitle: {
    fillColor: "#333333",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 400
  },
  metricsValue: {
    fillColor: "#333333",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 700
  }
}, C = (i, g, e, h, n, r, o = "space-between") => {
  const c = new m.Rect({
    fill: a.metricsContainer.fillColor,
    width: e,
    height: h,
    rx: 3,
    ry: 3
  }), { y: s } = c.getCenterPoint(), t = new m.Text(i, {
    ...a.metricsTitle,
    top: s,
    originY: "center",
    fontSize: p(a.metricsTitle.fontSize, r)
  }), l = new m.Text(g, {
    ...a.metricsValue,
    top: s,
    originY: "center",
    fontSize: p(a.metricsValue.fontSize, r)
  });
  if (o === "space-between")
    t.set({
      left: n,
      originX: "left"
    }), l.set({
      left: e - n,
      originX: "right"
    });
  else {
    const w = (t.width ?? 0) + n + (l.width ?? 0), f = (e - w) / 2;
    t.set({
      left: f,
      originX: "left"
    }), l.set({
      left: e - f,
      originX: "right"
    });
  }
  return new m.Group([c, t, l]);
}, x = (i, g, e, h, n, r) => {
  const o = (g - (i.length - 1) * n.gap) / i.length, c = i.map((t, l) => {
    const w = l * (o + n.gap), f = C(
      t.label,
      t.value,
      o,
      e,
      n.padding,
      n.fontSizeMultiplier,
      r ? "center" : "space-between"
    );
    return f.set({ left: w }), f;
  }), s = new m.Group(c);
  return s.set({ top: h }), s;
}, G = ({
  metrics: i,
  maxWidth: g = 264,
  fontSizeMultiplier: e = 1,
  padding: h = 10,
  columns: n = 2
}) => {
  if (!i.length)
    return;
  const r = S({
    maxLines: 1,
    ...a.metricsValue,
    fontSize: p(a.metricsValue.fontSize, e)
  }) + h * e * 2, o = 4, c = [...i];
  let s = 0;
  const t = [], l = c.length === 1;
  for (; c.length; ) {
    const f = c.splice(0, n), u = (r + o) * s;
    t.push(
      x(
        f,
        g,
        r,
        u,
        {
          padding: h,
          fontSizeMultiplier: e,
          gap: o
        },
        l
      )
    ), s++;
  }
  const w = new m.Rect({
    fill: "#ffffff",
    width: g,
    height: (r + o) * t.length - o
  });
  return new m.Group([w, ...t]);
};
export {
  G as createMetricsFabricObj
};
//# sourceMappingURL=index.es396.js.map
